import CLIUpload from "../../../../contents/docs/error-tracking/_snippets/cli/upload.mdx";
import * as React from 'react';
export default {
  CLIUpload,
  React
};